import { bluePaletteDark } from '../../../themes/dark-colors';

export const linkDarkTheme = {
  color: bluePaletteDark[600],
  hover: {
    color: bluePaletteDark[800],
  },
  active: {
    color: bluePaletteDark[900],
  },
};
